import { Form } from "@renderbus/ui";
import { FormInstance } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Input, Password } from "@renderbus/ui";
import styled from "styled-components";

export function VerificationForm({
  form,
  isEchoForm = false,
}: {
  form: FormInstance;
  isEchoForm?: boolean;
}) {
  const t = getTranslateNsT("childManager");
  return (
    <EchoFormWarpper isEchoForm={isEchoForm}>
      <div className="integration-item-title">
        {t(
          isEchoForm
            ? "dingtalk_subaccount_echo_text1"
            : "dingtalk_subaccount_create_text1"
        )}
        &nbsp;
        {!isEchoForm && (
          <VerificationFormItemHelperText
            href="https://www.renderbus.com/support-new/grzx/ddzzhgl/"
            target="_blank"
          >
            {t("dingtalk_subaccount_setting_step1_subtitle2")}
          </VerificationFormItemHelperText>
        )}
      </div>
      <Form
        size={"large"}
        form={form}
        layout="vertical"
        className="verification-form"
        style={{ width: 560, margin: "auto" }}
      >
        <Form.Item
          name="appKey"
          label={t("dngtalk_subaccount_setting_label_clientId")}
          rules={[{ required: !isEchoForm, message: "" }]}
        >
          {isEchoForm ? (
            <Input
              className={"dingtalk_addonafter"}
              value={form.getFieldValue("appKey")}
            />
          ) : (
            <Password className="background-2C2C31" />
          )}
        </Form.Item>
        <Form.Item
          name="appSecret"
          label={t("dngtalk_subaccount_setting_label_client_secret")}
          rules={[{ required: !isEchoForm, message: "" }]}
        >
          {isEchoForm ? (
            <Input
              className={"dingtalk_addonafter"}
              value={form.getFieldValue("appSecret")}
            />
          ) : (
            <Password className="background-2C2C31" />
          )}
        </Form.Item>
      </Form>
    </EchoFormWarpper>
  );
}

const EchoFormWarpper = styled.div<{ isEchoForm: boolean }>`
  position: ${(p) => p.isEchoForm && "relative"};
  height: ${(p) => p.isEchoForm && "calc(100vh - 46px)"};
`;

const VerificationFormItemHelperText = styled.a`
  color: var(--main-color);
  &:hover {
    color: var(--main-color);
  }
`;
